export const EXPERTISE_TYPE_OTHER = 'other';
